"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * API V1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ApiStoresPostRequestToJSON = exports.ApiStoresPostRequestFromJSONTyped = exports.ApiStoresPostRequestFromJSON = exports.instanceOfApiStoresPostRequest = void 0;
var StoreCreate_1 = require("./StoreCreate");
/**
 * Check if a given object implements the ApiStoresPostRequest interface.
 */
function instanceOfApiStoresPostRequest(value) {
    var isInstance = true;
    isInstance = isInstance && "store" in value;
    return isInstance;
}
exports.instanceOfApiStoresPostRequest = instanceOfApiStoresPostRequest;
function ApiStoresPostRequestFromJSON(json) {
    return ApiStoresPostRequestFromJSONTyped(json, false);
}
exports.ApiStoresPostRequestFromJSON = ApiStoresPostRequestFromJSON;
function ApiStoresPostRequestFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'store': (0, StoreCreate_1.StoreCreateFromJSON)(json['store']),
    };
}
exports.ApiStoresPostRequestFromJSONTyped = ApiStoresPostRequestFromJSONTyped;
function ApiStoresPostRequestToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'store': (0, StoreCreate_1.StoreCreateToJSON)(value.store),
    };
}
exports.ApiStoresPostRequestToJSON = ApiStoresPostRequestToJSON;
